const reducer = (state, action) => {
  const { type, payload } = action;
  return { ...state };
};

export default reducer;
